/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */

/* eslint-disable no-prototype-builtins */


import {isObject} from "@/utils/helpers";

export default class BaseObject {

	constructor(options){
	}

	applyOptions(options = {}){

		if(isObject(options)){
			let noUndefined = Object.keys(options).reduce((acc, key) => {
				if (options[key] !== undefined) {
					acc[key] = options[key];
				}
				return acc;
			}, {})
			Object.assign(this, noUndefined);
		}
	}

	resetObject(){

	}

	onCopied(){
		this.prepareForCopy()
	}

	prepareForCopy(){
		console.log("prepareForCopy: ", this)
	}

	equals(other){
		return this.equalsInternal(this, other)
	}


	static arraysEqual(a, b) {
		if (a === b) return true;
		if (a == null || b == null) return false;
		if (a.length !== b.length) return false;

		for (let i = 0; i < a.length; ++i) {
			let left = a[i]
			let right = b[i]
			if(left instanceof BaseObject){
				return left.equals(right)
			}
			if (a[i] !== b[i]) return false;
		}
		return true;
	}

	equalableProps(){
		return Object.keys(this)
	}
	equalablePropsExcluded(){
		return [
			"id",
			"createdAt"
		]
	}


	equalsInternal(x, y, leftChain = [], rightChain = []) {
		let p;


		// remember that NaN === NaN returns false
		// and isNaN(undefined) returns true
		if (isNaN(x) && isNaN(y) && typeof x === 'number' && typeof y === 'number') {
			return true;
		}

		// Compare primitives and functions.
		// Check if both arguments link to the same object.
		// Especially useful on the step where we compare prototypes
		if (x === y) {
			return true;
		}

		// Works in case when functions are created in constructor.
		// Comparing dates is a common scenario. Another built-ins?
		// We can even handle functions passed across iframes
		if ((typeof x === 'function' && typeof y === 'function') ||
			(x instanceof Date && y instanceof Date) ||
			(x instanceof RegExp && y instanceof RegExp) ||
			(x instanceof String && y instanceof String) ||
			(x instanceof Number && y instanceof Number)) {
			return x.toString() === y.toString();
		}

		// At last checking prototypes as good as we can
		if (!(x instanceof Object && y instanceof Object)) {
			console.log("equals false: !(x instanceof Object && y instanceof Object)")
			return false;
		}

		if (x.isPrototypeOf(y) || y.isPrototypeOf(x)) {
			console.log("equals false: x.isPrototypeOf(y) || y.isPrototypeOf(x)")
			return false;
		}

		if (x.constructor !== y.constructor) {
			console.log("equals false: x.constructor !== y.constructor: x.constructor = ", x.constructor, ", y.constructor = ", y.constructor)
			return false;
		}

		if (x.prototype !== y.prototype) {
			console.log("equals false: x.prototype !== y.prototype")
			return false;
		}

		// Check for infinitive linking loops
		if (leftChain.indexOf(x) > -1 || rightChain.indexOf(y) > -1) {
			console.log("equals false: leftChain.indexOf(x) > -1 || rightChain.indexOf(y) > -1")
			return false;
		}


		let propsX = (x.equalableProps ? x.equalableProps() : null) || Object.keys(x)
		let propsY = (y.equalableProps ? y.equalableProps() : null) || Object.keys(y)

		propsX = propsX.filter(props => !this.equalablePropsExcluded().includes(props))
		propsY = propsY.filter(props => !this.equalablePropsExcluded().includes(props))

		// Quick checking of one object being a subset of another.
		for (p of propsY) {
			if (y.hasOwnProperty(p) != x.hasOwnProperty(p)) {
				console.log("equals false: y.hasOwnProperty(p) != x.hasOwnProperty(p), p = ", p, ", x = ", x, ", y = ", y)
				return false;
			}
			else if (typeof y[p] != typeof x[p]) {
				console.log("equals false: typeof y[p] != typeof x[p]: typeof y[p] = ", typeof y[p], ", typeof x[p] = ", typeof x[p], ", p = ", p, ", x[p] = ", x[p], ", y[p] = ", y[p])
				return false;
			}
		}

		for (p of propsX) {
			if (y.hasOwnProperty(p) != x.hasOwnProperty(p)) {
				console.log("equals false: y.hasOwnProperty(p) != x.hasOwnProperty(p), p = ", p, ", x = ", x, ", y = ", y)
				return false;
			}
			else if (typeof y[p] != typeof x[p]) {
				console.log("equals false: typeof y[p] != typeof x[p]")
				return false;
			}

			switch (typeof (x[p])) {
				case 'object':
				case 'function':

					leftChain.push(x);
					rightChain.push(y);

					if (!this.equalsInternal(x[p], y[p], leftChain, rightChain)) {
						return false;
					}

					leftChain.pop();
					rightChain.pop();
					break;

				default:
					if (x[p] != y[p]) {
						console.log("equals false: x[p] != y[p]; x[p] = ", x[p], ", y[p] = ", y[p], ", p = ", p, ", leftChain = ", leftChain, ", rightChain = ", rightChain)
						return false;
					}
					break;
			}
		}

		return true;
	}

}
